import React, {useState} from 'react';
import {AddButton, ContentWrapper, Tags, TagSelectionWrapper, TextInput} from './TagPicker.style';
import {t} from 'i18next';
import {isValidText} from '../../utils';

export interface TagSelectionProps {
    readonly dataSource: string[];
    onChange: (changedTags: string[]) => void;
}

/**
 * @name TagPicker
 * @description
 * Component to make a selection of string tags that can describe an item
 */
export const TagPicker: React.VFC<TagSelectionProps> = (props) => {
    const [tagInput, setTagInput] = useState('');

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        let eventValue = e.target.value.toString();
        setTagInput(eventValue);
    };

    const handleSave = () => {
        if (validateInput()) {
            let tag = tagInput.trim();
            if (props.dataSource) {
                props.onChange([...props.dataSource, tag]);
            } else {
                props.onChange([tag]);
            }

            setTagInput('');
        }
    };

    const validateInput = (): boolean => {
        return (isValidText(tagInput) && (!props.dataSource.includes(tagInput))) as boolean;
    }

    const handleDelete = (tagDelete: string) => {
        if (!props.dataSource) {
            return;
        }

        props.onChange(props.dataSource.filter(tagKeep => (tagKeep !== tagDelete)));
    };

    return (
        <TagSelectionWrapper>
            <ContentWrapper>
                <TextInput
                    id={'inputIdTag'}
                    label={t('TAG_SELECTION_COMPONENT_FILE_TAG_LABEL')}
                    value={tagInput}
                    onChange={handleInput}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            handleSave();
                        }
                    }}
                />
                <AddButton
                    key='add'
                    icon='add'
                    mode='primary'
                    disabled={!validateInput()}
                    type='button'
                    label={t('TAG_SELECTION_COMPONENT_ADD_LABEL')}
                    onClick={handleSave}
                />
            </ContentWrapper>
            <ContentWrapper>
                {props.dataSource.map(tag => {
                    return <Tags key={tag} label={tag} buttonClose onClose={() => handleDelete(tag)}/>;
                })}
            </ContentWrapper>
        </TagSelectionWrapper>
    );
};
